var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:{'btn-wide': _vm.wide},attrs:{"depressed":"","dark":"","color":_vm.colors,"outlined":"","large":_vm.size},on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }